module.exports = __webpack_public_path__ + "static/media/bill.26f24436.svg";